import * as React from 'react';
import { FunctionComponent, ReactElement } from 'react';

import { BaseButton } from '../../../../../../shared/components/base-button/base-button';
import { useNavigateToRoute } from '../../../../../../shared/hooks/use-navigate-to-route/use-navigate-to-route.hook';
import Box from '../../../../../shared/components/ui/Box';
import FormControl from '../../../../../shared/components/ui/FormControl';
import useChangePrompt from '../../../../../shared/hooks/use-change-prompt/use-change-prompt.hook';

export const ActionButtons: FunctionComponent = (): ReactElement => {
  const navigateToCampaignsOverview = useNavigateToRoute('../../campaigns');
  const navigateToNextTab = useNavigateToRoute('../vehicle-population');

  const cancelAction = useChangePrompt(
    true,
    navigateToCampaignsOverview,
    <span>Warning</span>,
    <span>Filled information will be lost. Leave anyway?</span>
  );

  return (
    <FormControl
      classes={{
        root: 'button-container',
      }}
      data-testid="campaign-action-buttons-form-control"
    >
      <Box className="button-container-wrapper" data-testid="button-wrapper">
        <BaseButton className="btn btn-white" onClick={cancelAction}>
          Cancel
        </BaseButton>

        <BaseButton className="btn btn-primary" onClick={navigateToNextTab}>
          Next
        </BaseButton>
      </Box>
    </FormControl>
  );
};
